import { render, staticRenderFns } from "./Elections.vue?vue&type=template&id=35b84681&scoped=true&"
import script from "./Elections.vue?vue&type=script&lang=js&"
export * from "./Elections.vue?vue&type=script&lang=js&"
import style0 from "./Elections.vue?vue&type=style&index=0&id=35b84681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b84681",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VIcon,VRow,VSelect})
